<template>
  <AlertModal v-bind="$attrs">
    <ul class="request-errors">
      <li v-for="(field, name) in errors" :key="name">
        <p
          class="request-errors__error"
          v-for="(error, index) in field"
          :key="index"
        >
          {{ error }}
        </p>
      </li>
    </ul>
  </AlertModal>
</template>

<script>
import AlertModal from "./AlertModal";
export default {
  name: "RequestAlert",
  inheritAttrs: false,
  components: { AlertModal },
  props: {
    errors: {
      type: [Array, Object]
    }
  }
};
</script>

<style lang="scss">
.request-errors {
  @include nl();
  text-align: justify;
  margin-top: 15px;

  &__error {
    &::before {
      content: "— ";
    }
  }
}
</style>
